import { X } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui'
import VideoPlayer from '@/components/features/video/VideoPlayer'
import type { FollowupVideoPlayback } from '@/types/api'

/**
 * O overlay do player de video de acompanhamento.
 *
 * Extraido do FollowupVideosPanel da prova para que o painel de contexto e o banner
 * compartilhem o MESMO overlay — inclusive o aviso dos 5 minutos, que nao e decoracao: a
 * URL das renditions e assinada e expira, e sem essa frase o video que para no meio
 * parece defeito.
 *
 * Nao pede a URL: recebe o `playback` ja resolvido por quem tratou o clique. Gerar a URL
 * aqui a faria nascer contando os 5 minutos antes de o aluno decidir assistir.
 */

interface Props {
  playback: FollowupVideoPlayback
  onClose: () => void
}

export default function VideoPlaybackModal({ playback, onClose }: Props) {
  if (playback.sources.length === 0) return null

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <Card variant="elevated" padding="none" className="w-full max-w-3xl">
        <CardHeader className="p-4 border-b border-neutral-200 dark:border-neutral-700 flex items-center justify-between">
          <CardTitle className="truncate">{playback.title}</CardTitle>
          <button
            onClick={onClose}
            className="text-neutral-400 hover:text-neutral-900 dark:hover:text-white"
            aria-label="Fechar"
          >
            <X className="h-5 w-5" />
          </button>
        </CardHeader>
        <CardContent className="p-4 space-y-3">
          <VideoPlayer
            sources={playback.sources}
            posterUrl={playback.poster_url}
            mediaKey={playback.id}
          />

          <p className="text-xs text-neutral-400 dark:text-neutral-500">
            Link temporário, válido por 5 minutos. Feche e abra de novo se o vídeo parar.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
